<template>
	<v-card class="mx-auto">
		<v-row>
			<v-col>
				<v-toolbar
					color="deep-purple accent-4"
					dark
				>
					<v-toolbar-title>מאגר שאלות</v-toolbar-title>
					<v-spacer />

					<v-text-field
						v-model="questionText"
						clearable
						prepend-inner-icon="mdi-magnify"
					/>
					<!--			</v-toolbar-items>-->
				</v-toolbar>
			</v-col>
		</v-row>
		<v-row>
			<v-col v-from-here-to-end="-50">
				<v-data-table
					:headers="headers"
					:items="questions"
					:items-per-page="20"
					:footer-props="footerProps"
					class="elevation-1"
				>
					<template #top>
						<p class="mr-4">
							שאלות שנותרו : {{ questions.length }}
						</p>
					</template>
					<template v-slot:item.add="{ item }">
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									small
									fab
									v-bind="attrs"
									dark
									color="indigo"
									v-on="on"
									@click="addQuestion(item)"
								>
									<v-icon dark>
										mdi-plus
									</v-icon>
								</v-btn>
							</template>
							<span>הוסף שאלה</span>
						</v-tooltip>
					</template>
					<template v-slot:item.edit="{ item }">
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									small
									fab
									v-bind="attrs"
									dark
									color="green"
									v-on="on"
									@click="$emit('edit', item)"
								>
									<v-icon dark>
										mdi-pencil
									</v-icon>
								</v-btn>
							</template>
							<span>ערוך שאלה</span>
						</v-tooltip>
					</template>
					<template v-slot:item.question_type="{ item }">
						<type-display :type="item.question_type" />
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import { types } from "root/packages/closeapp/QuestionsManager/assets/store/Question.module";
import GameType from "src/types/GameType";
import TypeDisplay from "../../components/TypeDisplay";

export default {
	name: "QuestionSearch",
	components: { TypeDisplay },
	props: { selectedQuestions: Array },
	data () {
		return {
			questionText: "",
			currentPage: 1,
			headers: [
				{ text: "סוג שאלה", value: "question_type" },
				{
					text: "תוכן שאלה",
					align: "right",
					sortable: false,
					value: "question",
				},
				{ text: "תשובה נכונה", value: "answer.content" },
				{ text: "", align: "left", value: "add" },
				{ text: "", align: "left", value: "edit" },
			],
			footerProps: { "items-per-page-options": [10, 20, 50, 100] },
		};
	},
	computed: {
		game () {
			return this.$store.state.GameModule.game;
		},
		questions () {
			if (!this.game.type) return [];
			return (
				this.$store.state.QuestionModule.questions
					/* filter by search text */
					.filter((question) => {
						return (
							question.question.includes(this.questionText || "") ||
							question.tags.some((tag) =>
								tag.name.includes(this.questionText || "")
							)
						);
					})
					/* filter questiont Not chosen to this game */
					.filter((q) => !this.selectedQuestionsId.includes(q.id))
					/* filter by game type */
					.filter((q) => {
						// const columnType = GameType.getTypeName(q.question_type) || "";
						// if (!columnType) return false;
						// return this.game.type[columnType];
            return q.relevantTypes.includes(this.game.type.id);
					})
			);
		},
		selectedQuestionsId () {
			return this.selectedQuestions.map((q) => q.id);
		},
	},
	created () {
		this.$store.dispatch(types.FETCH);
	},
	methods: {
		addQuestion (question) {
			this.$emit("add", question);
		},
	},
};
</script>
